/* eslint-disable */
import { useState, useCallback, useRef } from 'react';
import moment from 'moment';
import { notificationServices } from '@/Services';
import aiPackaging from '@/Services/aiPackaging.services';

export const useMasterData = (props) => {
	const { subTab } = props;
	const [cacheTime, setCacheTime] = useState(null);
	const [rawData, setRawData] = useState([]);
	const lastFetchParams = useRef({});
	const [isLoading, setIsLoading] = useState(false);

	const fetchData = useCallback(
		async (filter, refresh = false) => {
			if (!refresh) {
				lastFetchParams.current.fetchData = { filter };
			}

			setIsLoading(true);
			const dateRange = filter?.dateRange;
			const req = {
				data: {
					dateRangeFilter: {
						from: moment(dateRange?.from).format('YYYY-MM-DD'),
						to: moment(dateRange?.to).format('YYYY-MM-DD'),
					},
					selectedTab: 'master',
					selectedSubTab: filter?.subTab || subTab,
					...(refresh ? { NO_CACHE: true } : {}),
				},
			};

			try {
				const response = await aiPackaging?.fetchFmsAnalyticsGrid(req);
				if (response?.statusCode === 200) {
					const { data } = response;
					if (response?.cacheTime) {
						setCacheTime(response?.cacheTime);
					} else {
						setCacheTime(null);
					}

					if (
						!data ||
						(Array.isArray(data?.data) &&
							data?.data.length === 0) ||
						(Array.isArray(data) && data.length === 0)
					) {
						console.log('Response data is empty');
						setRawData([]);
					} else {
						if (refresh) {
							setCacheTime('Just now');
						}
						setRawData(data);
					}
				} else {
					notificationServices?.generateNotification({
						type: 'error',
						message: response?.message,
					});
					setRawData([]);
				}
			} catch (error) {
				notificationServices?.generateNotification({
					type: 'error',
					message: error.message || 'Failed to fetch data',
				});
				setRawData([]);
			} finally {
				setIsLoading(false);
			}
		},
		[subTab]
	);

	const refresh = useCallback(async () => {
		if (lastFetchParams.current.fetchData) {
			const { filter } = lastFetchParams.current.fetchData;
			fetchData(filter, true);
		}
	}, [fetchData]);

	return {
		rawData,
		isLoading,
		fetchData,
		cacheTime,
		refresh,
	};
};
